import { render } from "./TwoFactor.vue?vue&type=template&id=d062b47a&ts=true"
import script from "./TwoFactor.vue?vue&type=script&lang=ts"
export * from "./TwoFactor.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__